/* The footer's +/- accordions on a phone. Same height animation as the
   header drawer, kept separate so the footer works on its own. */
(function () {
  'use strict';

  function init(root) {
    root.querySelectorAll('.rw-footer__acc-trigger').forEach(function (trigger) {
      if (trigger.dataset.rwInit === 'true') return;
      trigger.dataset.rwInit = 'true';

      var panel = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!panel) return;

      trigger.addEventListener('click', function () {
        var open = trigger.getAttribute('aria-expanded') === 'true';
        if (open) {
          panel.style.height = panel.scrollHeight + 'px';
          requestAnimationFrame(function () {
            panel.style.height = '0px';
            panel.style.opacity = '0';
          });
        } else {
          panel.style.height = panel.scrollHeight + 'px';
          panel.style.opacity = '1';
          panel.addEventListener('transitionend', function once(event) {
            if (event.propertyName !== 'height') return;
            panel.removeEventListener('transitionend', once);
            if (trigger.getAttribute('aria-expanded') === 'true') panel.style.height = 'auto';
          });
        }
        trigger.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
